import React from 'react';
import { StyledComponentProps, withStyles } from '@material-ui/core';
import { IconButton as MuiButton } from '@material-ui/core';
import { styles } from './styles';
import { ReactComponent as Down } from '../../images/icons/down.svg';

interface IProps extends StyledComponentProps {
    onClick: (e) => any;
    disabled?: boolean;
}

const ExpandDownButton = (props: IProps) => {
    return (<MuiButton
        disabled={props.disabled}
        className={props.classes.listIconButtonRootSvg}
        onClick={props.onClick}>
            <Down className={props.classes.listIconButtonSvg}/>
    </MuiButton>)
}


export default withStyles(styles)(ExpandDownButton)